import { CreateResponsiveStyle, DEVICE_SIZES, minSize, maxSize, } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    selectedItemWrapper:{
      width: 285,
      height: 73,
      borderRadius: 9.5,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 10,
    },
    KYCUpd_DocUploadContainer_col2_WarningText: {
      fontFamily: "Inter",
      fontSize: 8,
      color: "#db1a1a",
      marginTop: 5,
    },

    dropDownViewStyle: {
      width: 230,
      height: "100%",
      position: "relative",
      zIndex: 9999,
      opacity: 1,
    },

    dropdownHeaderHide: {
      backgroundColor: "#fff",
      width: "100%",
      height: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      zIndex: 9999,
      border: "2px solid #dfdfdf",
      padding: 10,
      borderRadius: 12,
    },

    dropdownHeader: {
      backgroundColor: "#fff",
      width: "100%",
      height: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      zIndex: 999,
      border: "2px solid #dfdfdf",
      padding: 10,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      borderBottomWidth: 0,
    },
    horizontalLine: {
      height: 0.5,
      width: "100%",
      backgroundColor: "#ccd0d5",
      display: "none",
      marginTop: 20,
    },
    RCUpdate_FunctionalityContainer: {
      flexDirection: "row",
      height: 240,
      marginTop: 20,
      paddingHorizontal: 20,
      zIndex: 1,
    },
    RCUpdate_SelectVehicleColumn: {
      height: "100%",
      width: "40%",
      position: "relative",
      zIndex: 999
    },
    RCUpdate_SelectVehicleTitle: {
      fontFamily: "Inter",
      fontSize: 15,
      color: "#5f5f5f",
    },
    RCUpdate_SelectVehicleSubtitle: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#5f5f5f",
      marginTop: 5,
    },
    dropDownViewStyleRC: {
      height: 50,
      marginTop: 20,
    },
    showDropdownRC: {
      display: "flex",
      border: "2px solid #dfdfdf",
      width: 230,
      position: "absolute",
      top: 40,
      zIndex: 9999,
      backgroundColor: "#fff",
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      boxShadow: "0 11px 11px 0 rgba(0, 0, 0, 0.16);",
      height: 120,
      overflowY: "scroll",
    },
    hideDropdownRC: { display: "none" },
    RCUpdate_UploadImageColumn: {
      height: "100%",
      width: "60%",
    },
    RCUpdate_UploadImageTitle: {
      fontFamily: "Inter",
      fontSize: 15,
      color: "#5f5f5f",
    },
    RCUpdate_UploadImageSubtitle: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#5f5f5f",
      marginTop: 5,
    },
    RCUpdate_UploadImageContainer: {
      flexDirection: "row",
      height: 90,
      marginTop: 20,
    },
    RCUpdate_ImageUploader: {
      border: "1.5px dashed #ccd0d5",
      borderRadius: 10,
      height: 90,
      width: 90,
      marginRight: 15,
      backgroundColor: "#ffffff",
    },
    frontImagePrevStyle: {
      width: 90,
      height: 90,
      borderRadius: 10,
      marginRight: 10
    },
    backImagePrevStyle:{
      width: 90,
      height: 90,
      borderRadius: 10,
    },
    RCUpdate_ImageUploader_InnerContainer: {
      width: "100%",
      height: "100%",
      justifyContent: "space-evenly",
      alignItems: "center",
      textAlign: "center",
      paddingBottom: 10,
    },

    RCUpdate_ImageUploader_PlusIcon: {
      fontSize: 35,
      color: "#02122c",
      opacity: "47%",
    },
    RCUpdate_ImageUploader_AddText: {
      fontSize: 11,
      fontFamily: "Inter",
      color: "#02122c",
      opacity: "47%",
    },
    RCUpdate_UploadImageButtons: {
      flexDirection: "row",
      justifyContent: "right",
      alignItems: "center",
      marginTop: 15,
      marginRight: "10%",
    },
    RCUpdate_UploadImageSubmit: {
      width: 200,
      height: 35,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#bd2d37",
      borderRadius: 16,
    },

    RCUpdate_UploadImageReset: {
      width: 125,
      height: 35,
      alignItems: "center",
      justifyContent: "center",
      border: "2px solid #bd2d37",
      borderRadius: 16,
      marginLeft: 10,
    },

    RCUpdate_UploadImageReset_Text: {
      fontFamily: "Inter",
      fontSize: 15,
      color: "#bd2d37",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    overlayContentViewStyle: {
      width: 348.1,
      height: 269.7,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    enterOtpTextStyle: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 21,
      letterSpacing: 0.64,
      textAlign: "center",
      color: "#66625f",
      paddingTop: 20,
    },
    otpDescTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 10,
      marginHorizontal: 30,
    },
    otpInputViewStyle: {
      width: 250.4,
      height: 38,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 1.5,
      borderColor: "#dfdfdf",
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 3.6,
      textAlign: "left",
      color: "#66625f",
      borderRadius: 5,
      marginTop: 20,
      alignSelf: "center",
      paddingLeft: 10,
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "15%",
      marginTop: 5,
    },
    enterRcViewStyle: {
      width: "100%",
      height: 180,
      borderRadius: 12.9,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      marginTop: 15,
    },
    enterRcBodyViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    rcViewStyle: {
      flexDirection: "row",
      marginLeft: 10,
      justifyContent: "space-between",
      width: "50%",
    },
    rcNumberTextStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 14.4,
      letterSpacing: 0.24,
      textAlign: "left",
      color: "#66625f",
      marginRight: 10,
      marginTop: 10,
    },
    rcInputViewStyle: {
      width: 115,
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
  },

  {
    [maxSize(DEVICE_SIZES.MD)]: {
      RCUpdate_FunctionalityContainer: {
        flexDirection: "column",
        height: 530,
      },
      RCUpdate_SelectVehicleColumn: {
        width: "100%",
        height: 130,
        marginTop: 10,
      },
      RCUpdate_UploadImageColumn: {
        width: "100%",
        height: 350,
        marginTop: 10,
      },
      enterRcViewStyle: {
        height: 329,
      },
      enterRcBodyViewStyle: {
        flexDirection: "column",
      },
      rcViewStyle: {
        justifyContent: "center",
        width: "100%",
        marginTop: 10,
      },
      rcInputViewStyle: {
        width: 300,
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
      },
      orTextStyle: {
        marginTop: 20,
      },
      horizontalLine: {
        display: "flex",
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      dropDownViewStyle: {
        width: "90%",
      },

      RCUpdate_FunctionalityContainer: {
        paddingHorizontal: 0,
      },
      rcViewStyle:{
        flexDirection:'column',
        paddingLeft:40
      },
      rcNumberTextStyle:{
        marginBottom:5
      }
    },
    [maxSize(DEVICE_SIZES.XS)]: {
      rcInputViewStyle: {
        width: 165,
        flexDirection: "column",
      },
      RCUpdate_UploadImageSubmit: {
        width: 100,
      },
      RCUpdate_UploadImageReset: {
        width: 100,
      },
      RCUpdate_UploadImageButtons: {
        alignItems: "center",
        justifyContent: "center",
        marginRight: 0
      },
      rcViewStyle:{
        flexDirection:'column',
        paddingLeft:40
      },
      rcNumberTextStyle:{
        marginBottom:5
      }
    },
  }
);

export default useStyles;